import React, { Component } from "react";
import { Card, CardDeck, Row, Col, Container, Button } from "react-bootstrap";
import "../css/Managehssestyle.css";
import 'bootstrap/dist/css/bootstrap.css';
import '../css/customBootstrapExtended.css'
import '../css/UpdateUserProfile.css';
import '../css/MyReportstylee.css'
import AdvanceTable from '../components/Tables/AdvanceTable';
import CustomHeader from '../components/Header'
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import BasicTable from "../components/Tables/BasicTable";
import SelectionTable from "../components/Tables/SelectionTable";
import VRNBox from "../components/VRNBox";
import Stepper from 'react-stepper-horizontal';
import axios from 'axios'


function Iframe(props) {
  console.log("URL Calling : ", props.src)
  return (
    <div>
      <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
    </div>
  )
}

const currentDate = new Date();


class MyReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showReport: false,
      showTrendReport: false,
      srcTrendURL: '',
      srcURL: '',
      reportBaseURL: 'https://altpaymerchants.com/TELEMATICSREPORTINGSERVICE/Reports?',
      reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
      reportViewType: '/SSSAS_TabularReports/',
      UserBranchID: this.props.data.selectedBranchId,
      reportDuration: 3,
      reportName: '',
      reportStartDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10),
      reportEndDate: new Date().toISOString().substring(0, 10),
      trendReportType: '',
      trendReportDuration: '',
      GeneralReportsteps: [
        {
          title: 'Step One',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 1)
          }
        },
        {
          title: 'Step Two',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 2)
          }
        }
      ],
      GRcurrentStep: 0,
      TrendReportsteps: [
        {
          title: 'Step One',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 1)
          }
        },
        {
          title: 'Step Two',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 2)
          }
        }
      ],
      TRcurrentStep: 0,

      data: [
        { "id": "ABC-123", "code": "500 KM", "name": "Jan" },
        { "id": "XYZ-456", "code": "89.6 KM", "name": "Feb" },
        { "id": "FDS-123", "code": "756 KM", "name": "Mar" },
      ],
      columns: [
        { "HeaderText": "VRN", "MappingColomn": "id" },
        { "HeaderText": "Mileage", "MappingColomn": "code" },
        { "HeaderText": "Month", "MappingColomn": "name" }
      ],
      PageSize: 5,
      Option: 1,
      Group: 0,
      Vehicle: 0,
      TrendOption: 1,
      TrendGroup: 0,
      TrendVehicle: 0,

    };

    this.onClickNext_GR = this.onClickNext_GR.bind(this);
    this.onClickPrevious_GR = this.onClickPrevious_GR.bind(this)
    this.onClickNext_TR = this.onClickNext_TR.bind(this);
    this.onClickPrevious_TR = this.onClickPrevious_TR.bind(this)

    this.handleChange = this.handleChange.bind(this)

    this.optionChange = this.optionChange.bind(this)
    this.groupChange = this.groupChange.bind(this)
    this.vehicleChange = this.vehicleChange.bind(this)
    this.fetchReport = this.fetchReport.bind(this)

    this.TrendoptionChange = this.TrendoptionChange.bind(this)
    this.TrendgroupChange = this.TrendgroupChange.bind(this)
    this.TrendvehicleChange = this.TrendvehicleChange.bind(this)

    this.generalReportSubmitHandler = this.generalReportSubmitHandler.bind(this)
    this.trendReportSubmitHandler = this.trendReportSubmitHandler.bind(this)
  }

  onClickNext_GR() {
    console.log(this.state.GRcurrentStep)
    if (this.state.GRcurrentStep < 1)
      this.setState({
        GRcurrentStep: this.state.GRcurrentStep + 1,
      });
  }

  onClickPrevious_GR() {
    console.log(this.state.GRcurrentStep)
    if (this.state.GRcurrentStep > 0)
      this.setState({
        GRcurrentStep: this.state.GRcurrentStep - 1,
      });
  }

  onClickNext_TR() {
    console.log(this.state.TRcurrentStep)
    if (this.state.TRcurrentStep < 1)
      this.setState({
        TRcurrentStep: this.state.TRcurrentStep + 1,
      });
  }

  onClickPrevious_TR() {
    console.log(this.state.TRcurrentStep)
    if (this.state.TRcurrentStep > 0)
      this.setState({
        TRcurrentStep: this.state.TRcurrentStep - 1,
      });
  }

  fetchReport() {
    this.setState({ showReport: true })
    //alert("working")
  }

  async optionChange(selectedOption) {
    //debugger;
    console.log("Selected Option is ", selectedOption)

    if (this.state.Option != selectedOption && selectedOption == 1) {
      await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
      //this.getAnalyticsData()
    }
    else
      this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })

    console.log('selected dropdown option is now ', this.state.Option)
  }

  async vehicleChange(selectedVehicle) {
    console.log(selectedVehicle)
    await this.setState({ Vehicle: selectedVehicle, Group: 0 })
    //this.getAnalyticsData()

  }

  async groupChange(selectedGroup) {
    console.log(selectedGroup)

    await this.setState({ Group: selectedGroup, Vehicle: 0 })
    //this.getAnalyticsData()

  }

  async TrendoptionChange(selectedOption) {
    //debugger;

    if (this.state.TrendOption != selectedOption && selectedOption == 1) {
      await this.setState({ TrendOption: selectedOption, TrendGroup: 0, TrendVehicle: 0 })
      //this.getAnalyticsData()
    }
    else
      this.setState({ TrendOption: selectedOption, TrendGroup: 0, TrendVehicle: 0 })

    console.log('selected dropdown option is now ', this.state.TrendOption)
  }

  async TrendvehicleChange(selectedVehicle) {
    console.log(selectedVehicle)
    await this.setState({ TrendVehicle: selectedVehicle, TrendGroup: 0 })
    //this.getAnalyticsData()

  }

  async TrendgroupChange(selectedGroup) {
    console.log(selectedGroup)

    await this.setState({ TrendGroup: selectedGroup, TrendVehicle: 0 })
    //this.getAnalyticsData()

  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  generalReportSubmitHandler(e) {
    console.log("Selected vehicle is ", this.state.Vehicle)
    e.preventDefault();
    console.log("Running Tabular Report")
    this.setState({ showReport: false })
    let fromDate = this.GetFormattedDate(this.state.reportStartDate)
    let toDate = this.GetFormattedDate(this.state.reportEndDate)
    let UserBranchID = this.state.UserBranchID
    let reportName = this.state.reportName
    let URL_PARAMETERS = 'reportName=' + reportName + '&FromDate=' + fromDate + '&ToDate=' + toDate + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
    if (this.state.Option == '2' || this.state.Option == '3') {
      if (this.state.Option == '2')
        URL_PARAMETERS += '&VRNGroupingID=' + this.state.Group
      else if (this.state.Option == '3')
        URL_PARAMETERS += '&MappingMasterID=' + this.state.Vehicle
    }
    let reportViewType = this.state.reportViewType
    let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
    console.log('URL Generated: ', ReportFullURL)
    this.setState({ srcURL: ReportFullURL, showReport: true })
  }

  trendReportSubmitHandler(e) {
    console.log("Running Chart Report")
    e.preventDefault();
    //alert("test")
    console.log('Report type is ' + this.state.trendReportType + ' for the duration of : ' + this.state.trendReportDuration)
    this.setState({ showTrendReport: false })

    let UserBranchID = this.state.UserBranchID
    let reportDuration = this.state.trendReportDuration

    let reportName = this.state.trendReportType
    let reportViewType = this.state.reportViewType

    let URL_PARAMETERS = 'reportName=' + reportName + '&DateRange=' + reportDuration + '&SelectedCriteria=' + 'vrn' + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

    if (this.state.TrendOption == '2' || this.state.TrendOption == '3') {
      if (this.state.TrendOption == '2')
        URL_PARAMETERS += '&VRNGroupingID=' + this.state.TrendGroup
      else if (this.state.TrendOption == '3')
        URL_PARAMETERS += '&MappingMasterID=' + this.state.TrendVehicle
    }

    let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
    console.log('URL Generated: ', ReportFullURL)
    this.setState({ srcTrendURL: ReportFullURL, showTrendReport: true })


  }

  GetFormattedDate(dateToConvert) {
    var date = new Date(dateToConvert)
    return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
  }

  componentDidMount() {
  }

  render() {
    console.log("Report Props: ", this.props)
    const { GeneralReportsteps, GRcurrentStep } = this.state;
    const { TrendReportsteps, TRcurrentStep } = this.state;
    const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };

    return (

      <div>

        {/* <CustomHeader></CustomHeader> */}

        <section id="nav-justified">

          <div className="row">
            <div className="col-sm-12">
              <div className="card overflow-hidden">
                <div className="card-header">
                  <h4 className="card-title" >My Reports</h4>
                </div>
                <div className="card-content">
                  <div className="card-body">
                    <p style={{ textAlign: 'left' }}>Please select which report you want to view</p>


                    <ul
                      className="nav nav-tabs nav-justified"
                      id="myTab2"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          id="home-tab-justified"
                          data-toggle="tab"
                          href="#home-just"
                          role="tab"
                          aria-controls="home-just"
                          aria-selected="true"
                        >
                          General Reports
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          id="profile-tab-justified"
                          data-toggle="tab"
                          href="#profile-just"
                          role="tab"
                          aria-controls="profile-just"
                          aria-selected="true"
                        >
                          Trend Reports
                        </a>
                      </li>
                    </ul>
                    {/* Tab panes */}
                    <div className="tab-content pt-1">
                      <div
                        className="tab-pane active"
                        id="home-just"
                        role="tabpanel"
                        aria-labelledby="home-tab-justified"
                      >
                        <div className="row match-height">
                          <div className="col-12">

                            <Card>
                              <Card.Title className="card-header">
                                General Reports
                              </Card.Title>
                              <Card.Body className="card-content">

                                <Stepper
                                  steps={GeneralReportsteps}
                                  activeStep={GRcurrentStep}
                                  activeColor="#ffd500"
                                  defaultBarColor="#ffd500"
                                  completeColor="red"
                                  // completeColor="red"
                                  completeBarColor="#ffd500"
                                  defaultBorderColor="green"
                                />


                                {GRcurrentStep === 0 && (
                                  <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                      <GroupVRNSelect

                                        showVehiclesInDropDown='yes'
                                        isMultiInGroup='false'
                                        isMultiInVehicle='false'
                                        onOptionChange={this.optionChange}
                                        onGroupChange={this.groupChange}
                                        onVehicleChange={this.vehicleChange}

                                      ></GroupVRNSelect>
                                    </div>


                                  </>

                                )}


                                {GRcurrentStep === 1 && (
                                  <>

                                    <form className="form" onSubmit={this.generalReportSubmitHandler} >
                                      <div className="form-body">
                                        <div className="row">
                                          <div className="col-md-6 col-12">
                                            <div className="form-group">
                                              {/* <label htmlFor="ReportType">Choose Report Type</label> */}
                                              <p className="text-left">Choose Report Type</p>
                                              <select class="form-control" name='reportName' onChange={this.handleChange.bind(this)} required>
                                                <option value="">
                                                  Please Select
                                                </option>
                                                <option value="ShellCardTransactions">
                                                  Shell Card Transactions
                                                </option>
                                                <option value="HSSEIncidents">
                                                  HSSE Incidents
                                                </option>
                                                <option value="HSSEViolations">
                                                  HSSE Violations
                                                </option>
                                                <option value="DeviatedRouteTransaction">
                                                  Alert Delivery Report
                                                </option>

                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-md-6 col-12">
                                            &nbsp;
                                          </div>
                                          <div className="col-md-6 col-12">
                                            <div className="form-label-group">
                                              <input type="date" id="dpStartTime" name="reportStartDate" value={this.state.reportStartDate} onChange={this.handleChange.bind(this)} className="form-control" />
                                              <label htmlFor="country-floating">Choose Start Time</label>
                                            </div>
                                          </div>
                                          <div className="col-md-6 col-12">
                                            <div className="form-label-group">
                                              <input type="date" id="dpEndTime" name="reportEndDate" value={this.state.reportEndDate} onChange={this.handleChange.bind(this)} className="form-control" />
                                              <label htmlFor="country-floating">Choose End Time</label>
                                            </div>
                                          </div>
                                          <div className="col-12">
                                            <button type="submit" className="btn btn-shell mr-1 mb-1">Generate Report</button>
                                          </div>

                                          <div className="col-md-12 col-12">
                                            {this.state.showReport && <Iframe src={this.state.srcURL} height="800" width="100%" />}
                                          </div>
                                        </div>
                                      </div>


                                    </form>



                                  </>

                                )}


                                <div >

                                {this.state.GRcurrentStep != 0 && 
                                  <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious_GR}>Previous</Button></div>
                                }
                                  
                                  {this.state.GRcurrentStep != 1 && 
                                  <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext_GR}>Next</Button></div>
                                  }
                                </div>




                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane"
                        id="profile-just"
                        role="tabpanel"
                        aria-labelledby="profile-tab-justified"
                      >
                        <div className="row match-height">
                          <div className="col-12">
                            <Card>
                              <Card.Title className="card-header">
                                Trend Reports
                              </Card.Title>
                              <Card.Body>

                                <Stepper
                                  steps={TrendReportsteps}
                                  activeStep={TRcurrentStep}
                                  activeColor="#ffd500"
                                  defaultBarColor="#ffd500"
                                  completeColor="red"
                                  // completeColor="red"
                                  completeBarColor="#ffd500"
                                  defaultBorderColor="green"
                                />


                                {TRcurrentStep === 0 && (
                                  <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                      <GroupVRNSelect
                                        showVehiclesInDropDown='yes'
                                        isMultiInGroup='false'
                                        isMultiInVehicle='false'
                                        onOptionChange={this.TrendoptionChange}
                                        onGroupChange={this.TrendgroupChange}
                                        onVehicleChange={this.TrendvehicleChange}
                                      ></GroupVRNSelect>
                                    </div>


                                  </>

                                )}


                                {TRcurrentStep === 1 && (
                                  <>
                                    <form className="form" onSubmit={this.trendReportSubmitHandler}>
                                      <div className="form-body">
                                        <div className="row">
                                          <div className="col-md-6 col-12">
                                            <div className="form-group">
                                              {/* <label htmlFor="ReportType">Choose Trend</label> */}
                                              <p className="text-left">Choose Trend</p>
                                              <select
                                                className="custom-select form-control"
                                                id="location1"
                                                name="trendReportType"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                              >
                                                <option value="">
                                                  Please Select
                                                </option>

                                                <option value="HSSEViolationsTrend">
                                                  HSSE Incidents
                                                </option>
                                                <option value="ShellCardTransactionsTrend">
                                                  VehicleOverviewReport
                                                </option>
                                                <option value="ShellCardSuspeciousTransactions">
                                                  Suspicious Transactions (No. & PKR)
                                                </option>
                                                <option value="HSSEViolationsScoreTrend">
                                                  HSSE Score
                                                </option>
                                              </select>
                                            </div>
                                          </div>

                                          <div className="col-md-6 col-12">
                                            <div className="form-group">
                                              <p className="text-left">Choose Time Frame</p>
                                              <select
                                                className="custom-select form-control"
                                                id="location1"
                                                name="trendReportDuration"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                              >
                                                <option value="">
                                                  Please Select
                                                </option>
                                                <option value="Three_Month">
                                                  Last 3 months
                                                </option>
                                                <option value="Six_month">
                                                  Last 6 months
                                                </option>
                                                <option value="Nine_Month">
                                                  Last 9 months
                                                </option>
                                                <option value="Year">
                                                  Last 12 months
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-12">
                                            <button type="submit" className="btn btn-shell mr-1 mb-1">Generate Trend</button>
                                          </div>
                                          <div className="col-md-12 col-12" id='number'>
                                            {this.state.showTrendReport && <Iframe src={this.state.srcTrendURL} height="800" width="100%" />}
                                          </div>


                                        </div>
                                      </div>
                                    </form>

                                  </>
                                )}

                                <div >
                                  
                                {this.state.TRcurrentStep != 0 && 
                                  <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious_TR}>Previous</Button></div>
                                }

                                {this.state.TRcurrentStep != 1 &&
                                  <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext_TR}>Next</Button></div>
                                
                                }
                                
                                </div>


                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


    );
  }
}
export default MyReports;